import React from 'react'
import { SuccessOverlay as DesignSystemSuccessOverlay } from '@t-one-internal/design-system'

const SuccessOverlay: React.FC = () => (
  <DesignSystemSuccessOverlay
    title="Recognition Sent!"
    subtitle="Your appreciation has been shared"
  />
)

export default SuccessOverlay
